import { updateEditVehicleRequest } from "actions/updateEditVehicleRequest";
import { updateEditProviderRequest } from "actions/updateEditProviderRequest";
import { getRegionIds } from "domains/Settings/DisposalSites/DataMappers/ManageDisposalSiteMapper";
import IEditProviderRequestModel from "interfaces/Request/IEditProviderRequestModel";
import IEditVehicleRequestModel from "interfaces/Request/IEditVehicleRequestModel";
import { useStateMachine } from "little-state-machine";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { RoutePathsEnum } from "infrastructure/RoutePathsEnum";

const EditTemplate = (props: any): any => {
  const navigate = useNavigate();
  const { actions } = useStateMachine({ updateEditVehicleRequest, updateEditProviderRequest });
  const {
    id,
    name,
    type,
    active,
    regions,
    trackerId,
    trackingDeviceName,
    registration,
    aOmPassword,
    isVehicle,
    userEmailAddress,
    notes,
    inUse
  } = props;

  const onEditClickHandler = () => {
    if (isVehicle) {
      const editVehicleRequest: IEditVehicleRequestModel = {
        id,
        name,
        type,
        active,
        regions: getRegionIds(regions),
        trackingId: trackerId,
        trackingDeviceName,
        registration,
        aOmPassword,
        inUse
      };

      actions.updateEditVehicleRequest(editVehicleRequest);
      navigate(RoutePathsEnum.SettingsCollectorsVehiclesUpdate);
    } else {
      const editProviderRequest: IEditProviderRequestModel = {
        id,
        name,
        emailAddress: userEmailAddress,
        type,
        active,
        regions: getRegionIds(regions),
        notes,
        inUse
      };
      actions.updateEditProviderRequest(editProviderRequest);
      navigate(RoutePathsEnum.SettingsCollectorsProvidersUpdate);
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <Button
        variant="primary"
        data-testid="edit-collector"
        aria-label={`Edit ${name} ${isVehicle ? "Vehicle" : "Provider"} `}
        onClick={onEditClickHandler}
      >
        Edit
      </Button>
    </div>
  );
};
export default EditTemplate;
